var map = {
	"./client/config/navigation.js": "cc41",
	"./company/config/navigation.js": "204a",
	"./diet_management_kitchen/config/navigation.js": "344c",
	"./diet_management_nurse/config/navigation.js": "3cd4",
	"./diet_management_nutritionist/config/navigation.js": "3027",
	"./general_service/config/navigation.js": "e86a",
	"./human_resources/config/navigation.js": "6ca0",
	"./patient/config/navigation.js": "edbe",
	"./pharmacy/config/navigation.js": "4a22",
	"./user/config/navigation.js": "7dc6"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a7ef";
module.exports = webpackAsyncContext;